class MandateFlowPresenter {
    constructor(usecase) {
        this.usecase = usecase;
    }
    uploadMandateImg(req) {
        return new Promise((resolve, reject) => {
            this.usecase.uploadMandate.execute({
                onSuccess: (data) => resolve(data.data),
                onError: (error) => reject(error),
            }, req);
        });
    }
    createMandate(req) {
        return new Promise((resolve, reject) => {
            this.usecase.createMandate.execute({
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            }, req);
        });
    }
    getMfBankDetails() {
        return new Promise((resolve, reject) => {
            this.usecase.mfBankDetails.execute({
                onSuccess: (data) => resolve(data.data),
                onError: (error) => reject(error),
            }, null);
        });
    }
    getMfMandate() {
        return new Promise((resolve, reject) => {
            this.usecase.mfMandate.execute({
                onSuccess: (data) => resolve(data.data),
                onError: (error) => reject(error),
            }, null);
        });
    }
    downloadMandate(req) {
        return new Promise((resolve, reject) => {
            this.usecase.downloadMandate.execute({
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            }, req);
        });
    }
    mandateSwitch() {
        return new Promise((resolve, reject) => {
            this.usecase.mandateSwitch.execute({
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            }, null);
        });
    }
    getEmandateUrl(req) {
        return new Promise((resolve, reject) => {
            this.usecase.getEmandateUrl.execute({
                onSuccess: (data) => resolve(data),
                onError: (error) => reject(error),
            }, req);
        });
    }
}
export default MandateFlowPresenter;
